import { useState, useEffect } from "react";
import "./styles.sass";
import assets from "../../assets";
import useHandler from "./handler";
import { useSingleton } from "../../hooks/use-singleton";
import { useNavigate, useLocation } from "react-router-dom";
import { SignUp } from "../sign-up";
import signupHandler from "../sign-up/handler";
import { ROUTE_DASHBOARD } from "../../route/studentRoute";
import { ROUTE_DASHBOARD as TnpscRoute } from "../../route/tnpscRoute";
import { ROUTE_DASHBOARD as NeetJ2ERoute, ROUTE_COMPETITIVE_EXAM } from "../../route/neetJteRoute";
import { COOKIE_ACCESS_SUBSCRIPTION_STATUS } from "../../utils/storage-constants";
import {
  ROUTE_STUDENT_MANAGEMENT,
  ROUTE_DASHBOARD as ROUTE_USER_DASHBOARD,
} from "../../route";

export const Login = () => {
  const {
    data,
    showPassword,
    error,
    isLoading,
    setShowPassword,
    onChangeValue,
    onSubmit,
    toggleCheck,
    onResetPassword,
  } = useHandler();
  const signup = signupHandler();

  const { role, board, examType } = useSingleton();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSignUpMode, setIsSignUpMode] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [showSignupSuccess, setShowSignupSuccess] = useState(false);

  useEffect(() => {
    if (location.state?.signupSuccess) {
      setShowSignupSuccess(true);
      setIsSignUpMode(false);
      // Clean up state so it doesn't show again on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const { email, password, check } = data;
  const { errEmail, errPassword } = error;

useEffect(() => {
   const subscriptionStatus = localStorage.getItem(
    COOKIE_ACCESS_SUBSCRIPTION_STATUS
  );

  const isInactive = subscriptionStatus === "inactive";

  if (isInactive) {
    navigate(ROUTE_COMPETITIVE_EXAM, { replace: true });
  } else if (role === "student") {
    navigate(ROUTE_USER_DASHBOARD, { replace: true });
  } else if (role === "aspirant" && examType?.startsWith("TNPSC")) {
    navigate(TnpscRoute, { replace: true });
  } else if (role === "aspirant" && examType?.startsWith("UPSC")) {
    navigate(ROUTE_DASHBOARD, { replace: true });
  } else if (
    role === "aspirant" &&
    (board === "NEET" || board === "JEE")
  ) {
    navigate(NeetJ2ERoute, { replace: true });
  } else if (role === "admin") {
    navigate(ROUTE_STUDENT_MANAGEMENT, { replace: true });
  }
}, [role, board, examType, navigate])

  return (
    <div className={`main_login_container ${isSignUpMode ? "sign-up-mode" : ""}`}>
      {showSignupSuccess && (
        <div className="signup_success_banner">
          <div className="signup_success_icon">✓</div>
          <div className="signup_success_text">
            <strong>Account Created!</strong>
            <span>You have successfully registered. Please sign in to continue.</span>
            <span>🔑 Your password has been sent to your email.</span>
          </div>
          <button className="signup_success_close" onClick={() => setShowSignupSuccess(false)}>×</button>
        </div>
      )}
      <div className="forms-container">
        <div className="signin-signup">
          {/* SIGN IN FORM */}
          <div className="login_form_section sign-in-form">
            <div className="form_header">
              <div className="center_logo_bg">
                <img src={assets.ic_login_graudate_white} alt="grad_icon" />
              </div>
              <h2 className="welcome_header">Sign In</h2>
              <p className="sub_welcome_text">Welcome! Sign in to continue your learning journey.</p>
            </div>
            <div className="input_group">
              <div className={`input_field ${errEmail ? "error_border" : ""}`}>
                <img src={assets.ic_mail_box} alt="mail" className="field_icon" />
                <input
                  placeholder="Email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={onChangeValue}
                  onKeyDown={(e) => e.key === "Enter" && onSubmit()}
                />
              </div>
              {errEmail && <p className="err_text">{errEmail}</p>}
            </div>

            <div className="input_group">
              <div className={`input_field ${errPassword ? "error_border" : ""}`}>
                <img src={assets.ic_password_box} alt="lock" className="field_icon" />
                <input
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={onChangeValue}
                  onKeyDown={(e) => e.key === "Enter" && onSubmit()}
                />
                <img
                  src={showPassword ? assets.ic_eye : assets.ic_closed_eye}
                  alt="toggle"
                  className="eye_toggle"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
              {errPassword && <p className="err_text">{errPassword}</p>}
            </div>

            <div className="form_actions">
              <div className="remember_me_container" onClick={toggleCheck}>
                <div className={`styled_checkbox ${check ? "active" : ""}`}>
                  {check && <div className="check_mark"></div>}
                </div>
                <span>Remember me</span>
              </div>
              <span className="forgot_link" onClick={onResetPassword}>
                Forgot Password?
              </span>
            </div>

            <button className="primary_signin_btn" onClick={onSubmit} disabled={isLoading}>
              {isLoading ? <div className="loader"></div> : <span>Login</span>}
            </button>
          </div>

          {/* SIGN UP FORM */}
          <div className="login_form_section sign-up-form">
            <SignUp
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              handler={signup}
            />
            <button
              className="primary_signin_btn"
              onClick={() => {
                const { isValid } = signup.onValidate(activeStep);
                if (!isValid) return;
                activeStep < 3
                  ? setActiveStep((prev) => prev + 1)
                  : signup.onSubmit();
              }}
            >
              <span>{activeStep === 3 ? "Complete" : "Next"}</span>
            </button>
          </div>
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <div className="content">
            <div className="brand_name">ROVIAN</div>
            <p>
              Your AI-powered learning journey starts here. Join Rovian and master any subject at your own pace.
            </p>
            <button className="btn transparent" onClick={() => setIsSignUpMode(true)}>
              Sign Up
            </button>
          </div>
          <img src="https://i.ibb.co/6HXL6q1/Privacy-policy-rafiki.png" className="image" alt="" />
        </div>
        <div className="panel right-panel">
          <div className="content">
            <div className="brand_name">ROVIAN</div>
            <p>
              Welcome! Please sign in to access your account and resume your professional development.
            </p>
            <button className="btn transparent" onClick={() => setIsSignUpMode(false)}>
              Sign In
            </button>
          </div>
          <img src="https://i.ibb.co/nP8H853/Mobile-login-rafiki.png" className="image" alt="" />
        </div>
      </div>
    </div>
  );
};
